import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FormControlPopupComponent } from './form-control-popup.component';
import { ButtonModule, InputModule, LinkModule, FormFieldModule } from '@shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    MatDialogModule,
    FormFieldModule,
    LinkModule,
    InputModule,
    TranslateModule
  ],
  declarations: [FormControlPopupComponent],
  exports: [FormControlPopupComponent],
})
export class FormControlPopupModule {}
